import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

import { GTM_LIST_LABEL } from './constants';

export const trackImpressionWithProductList = (
  products: GetProductsByIdBatchedQuery['vpProductByIds']
) => {
  dispatchTrackingEvent({
    event: 'view_item_list',
    product_lists: {
      products: products
        .filter((p): p is NonNullable<typeof p> => p != null)
        .map((product, index) =>
          ProductEventWither()
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .withVpProduct(product as any)
            .withDiscountPrices(product.attributes, {
              shouldSendOnlyDiscountPrice: true,
            })
            .withAdditionalData({ list_position: index + 1 })
            .build()
        ),
      interaction: 'scroll',
      sorting_type: 'automatic',
      list_id: undefined,
      list_name: GTM_LIST_LABEL,
    },
    _clear: true,
  });
};
